import $ from 'jquery'
import AssurePrestation from '@/views/parametres/assurances/liste-assures/assure-prestations'
import TauxPrestations from '@/views/parametres/assurances/liste-assures/assure-detail/taux-prestations'
// import AssureAnalyse from '@/views/parametres/assurances/liste-assures/assure-analyses'

export default {
	name: 'assure-detail',
	components: {
		AssurePrestation, TauxPrestations
	},
	props: [],
	data() {
		return {
			is_loading: true,
			assurance_id: 0
		}
	},

	computed: {
		souscripteur_detail() {
            return this.$store.getters["souscripteur_detail"];
        },
	},

	mounted() {
		this.assurance_id = this.$route.params.id
		this.$store.dispatch("getSouscripteurById", { assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id }).then(() => {
			this.is_loading = false
		});
	},
	
	methods: {
		changeTab(tabindex, t) {

            if (t == 1) {
                $('#shown-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#shown-tab-' + i).removeClass('active show');
                    }
                }
            } else {
                $('#hidden-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#hidden-tab-' + i).removeClass('active show');
                    }
                }
            }
        },
	}
}


